<template>
  <md-table
    v-model="billing"
    md-sort="date"
    md-sort-order="desc"
    table-header-color="primary"
  >
    <md-table-empty-state md-label="No records found" />
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="ID" md-sort-by="id">{{ item.id }}</md-table-cell>
      <md-table-cell md-label="Date" md-sort-by="date">{{
        $moment(item.created_at).format("DD/MM/YYYY h:m A")
      }}</md-table-cell>
      <md-table-cell md-label="Description" md-sort-by="description">
        <strong>{{ item.name }}</strong
        ><br />
        {{ item.user_name }}
      </md-table-cell>
      <!--      <md-table-cell md-label="Payment Method">-->
      <!--        {{ item.method }}-->
      <!--        <br />{{ item.cardno }}-->
      <!--      </md-table-cell>-->
      <md-table-cell md-label="Total Paid" md-sort-by="total"
        >${{ centsToDollars(item.price) }}</md-table-cell
      >
      <md-table-cell md-label="Invoice">
        <a v-if="item.receipt_pdf" :href="item.receipt_pdf" target="_blank">
          <font-awesome-icon class="fa-lg" icon="fa-solid fa-file-arrow-down" />
        </a>
        <span v-else>
          <font-awesome-icon class="fa-lg" icon="fa-solid fa-cross" />
        </span>
      </md-table-cell>
    </md-table-row>
  </md-table>
</template>
<script>
import ApiService from "@/services/api";
import { centsToDollars } from "@/util";

export default {
  name: "BillingHistoryTable",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      search: null,
      searched: [],
      billing: []
    };
  },
  created() {
    ApiService.pass.billing().then(response => {
      this.billing = response.data.data.passes;
    });
  },
  methods: {
    centsToDollars: centsToDollars
  }
};
</script>
<style></style>
